<template>
  <tbody>
    <Component
      v-for="(auction, index) in internetAuctions"
      :is="auction.type"
      :auction="auction"
      :key="index"
    />
  </tbody>
</template>

<script>
  import OrdersRow from './../orders/orders_row';
  import OrdersDetails from './../orders/orders_details';

  export default {
    name: 'MainTableBody',
    components: {
      OrdersRow,
      OrdersDetails,
    },
    props: {
      internetAuctions: {
        type: Array,
        required: true,
      },
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/employees_orders_panel/components/table/main_table_body.vue?3ca8fad5